module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "confirmacaoModal",
      "tabindex": "-1",
      "role": "dialog",
      "aria-labelledby": "confirmacaoModalLabel",
      "aria-hidden": "true"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-dialog-centered",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content panel-danger"
  }, [_c('div', {
    staticClass: "modal-header panel-heading"
  }, [_c('h4', {
    staticClass: "modal-title",
    attrs: {
      "id": "confirmacaoModalLabel"
    }
  }, [_vm._v(_vm._s(_vm.tituloModal))]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_vm._v("\n          " + _vm._s(_vm.mensagemModal) + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-secondary",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("Cancelar")]), _vm._v(" "), (_vm.isTurno) ? _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        return _vm.deletarTurno(_vm.turnoParaApagar)
      }
    }
  }, [_vm._v("Confirmar")]) : _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        return _vm.deletarParada(_vm.paradaParaApagar)
      }
    }
  }, [_vm._v("Confirmar")])])])])]), _vm._v(" "), _c('div', [_c('b-alert', {
    attrs: {
      "variant": "danger",
      "dismissible": "",
      "show": _vm.showDismissibleAlert
    },
    on: {
      "dismissed": function($event) {
        _vm.showDismissibleAlert = false
      }
    }
  }, [_vm._v("\n    " + _vm._s(_vm.messageAlert) + "\n  ")])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.exibirListagem),
      expression: "exibirListagem"
    }],
    staticClass: "row center-block"
  }, [_c('h2', [_vm._v("Listagem")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.exibirDetalharTurno),
      expression: "!exibirDetalharTurno"
    }],
    staticClass: "box-title"
  }, [_vm._v("Listagem dos Turnos Cadastrados")]), _vm._v(" "), _c('h3', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.exibirDetalharTurno),
      expression: "exibirDetalharTurno"
    }],
    staticClass: "box-title"
  }, [_vm._v("Alterar Dados do Turno")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.exibirDetalharTurno),
      expression: "!exibirDetalharTurno"
    }],
    staticClass: "box-body no-padding table-responsive"
  }, [_c('table', {
    staticClass: "table table-striped"
  }, [_c('tbody', [_vm._m(1), _vm._v(" "), _vm._l((_vm.turnos), function(turno) {
    return _c('tr', {
      key: turno.id
    }, [_c('td', [_vm._v(_vm._s(turno.nometurno))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(turno.horainicio))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(turno.horafim))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(turno.tempototal))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(turno.tempototalparada))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(turno.tempoutil))]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "text-center"
    }, [_c('a', {
      staticClass: "btn btn-sm",
      on: {
        "click": function($event) {
          return _vm.selecionarTurno(turno)
        }
      }
    }, [_vm._m(2, true)]), _vm._v(" "), _c('a', {
      staticClass: "btn btn-sm",
      attrs: {
        "data-toggle": "modal",
        "data-target": "#confirmacaoModal"
      },
      on: {
        "click": function($event) {
          return _vm.prepararDeletarTurno(turno)
        }
      }
    }, [_vm._m(3, true)])])])])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "box-footer"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.exibirListagem),
      expression: "exibirListagem"
    }],
    staticClass: "col-sm-4"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.novoTurno()
      }
    }
  }, [_vm._v("Novo Turno")])])])])])]), _vm._v(" "), (!_vm.exibirListagem) ? _c('div', {
    staticClass: "row center-block"
  }, [(_vm.turnoSelecionado.turno.id !== 0) ? _c('h2', [_c('a', {
    on: {
      "click": function($event) {
        return _vm.mostrarListagem()
      }
    }
  }, [_vm._v("Listagem ")]), _c('small', [_vm._v("Editar Turno")])]) : _vm._e(), _vm._v(" "), (_vm.turnoSelecionado.turno.id === 0) ? _c('h2', [_c('a', {
    on: {
      "click": function($event) {
        return _vm.mostrarListagem()
      }
    }
  }, [_vm._v("Listagem ")]), _c('small', [_vm._v("Cadastrar Turno")])]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.exibirDetalharTurno),
      expression: "exibirDetalharTurno"
    }],
    staticClass: "col-md-12"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.exibirNovaParada),
      expression: "!exibirNovaParada"
    }],
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Turno")]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-sm-12"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label",
    attrs: {
      "for": "textoDoTurno"
    }
  }, [_vm._v("Nome do Turno")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.turnoSelecionado.turno.nometurno),
      expression: "turnoSelecionado.turno.nometurno"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "textoDoTurno"
    },
    domProps: {
      "value": (_vm.turnoSelecionado.turno.nometurno)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.turnoSelecionado.turno, "nometurno", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "col-sm-1 control-label",
    attrs: {
      "for": "inicioDoTurno"
    }
  }, [_vm._v("Início")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2"
  }, [_c('vue-timepicker', {
    attrs: {
      "format": "HH:mm"
    },
    model: {
      value: (_vm.turnoSelecionado.horaInicio),
      callback: function($$v) {
        _vm.$set(_vm.turnoSelecionado, "horaInicio", $$v)
      },
      expression: "turnoSelecionado.horaInicio"
    }
  })], 1), _vm._v(" "), _c('label', {
    staticClass: "col-sm-1 control-label",
    attrs: {
      "for": "fimDoTurno"
    }
  }, [_vm._v("Término")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2"
  }, [_c('vue-timepicker', {
    attrs: {
      "format": "HH:mm"
    },
    model: {
      value: (_vm.turnoSelecionado.horaFim),
      callback: function($$v) {
        _vm.$set(_vm.turnoSelecionado, "horaFim", $$v)
      },
      expression: "turnoSelecionado.horaFim"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-sm-12"
  }, [_c('div', {
    staticClass: "col-sm-1"
  }, [_c('button', {
    staticClass: "btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.mostrarListagem()
      }
    }
  }, [_vm._v("Voltar")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-1"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.gravarTurno()
      }
    }
  }, [_vm._v("Gravar Turno")])])])])]), _vm._v(" "), (_vm.exibirNovaParada) ? _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('div', [(_vm.paradaSelecionada.parada.id === 0) ? _c('p', [_c('span', [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Nova Parada Programada - Turno " + _vm._s(_vm.turnoSelecionado.turno.nometurno))])])]) : _c('p', [_c('span', [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Editar Parada Programada - Turno " + _vm._s(_vm.turnoSelecionado.turno.nometurno))])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-sm-12"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label",
    attrs: {
      "for": "textoDoTurno"
    }
  }, [_vm._v("Nome da Parada")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.paradaSelecionada.parada.nomeparadaprogramada),
      expression: "paradaSelecionada.parada.nomeparadaprogramada"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "textoDoTurno"
    },
    domProps: {
      "value": (_vm.paradaSelecionada.parada.nomeparadaprogramada)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.paradaSelecionada.parada, "nomeparadaprogramada", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "col-sm-1 control-label",
    attrs: {
      "for": "inicioDoTurno"
    }
  }, [_vm._v("Início")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2"
  }, [_c('vue-timepicker', {
    attrs: {
      "format": "HH:mm"
    },
    model: {
      value: (_vm.paradaSelecionada.horaInicio),
      callback: function($$v) {
        _vm.$set(_vm.paradaSelecionada, "horaInicio", $$v)
      },
      expression: "paradaSelecionada.horaInicio"
    }
  })], 1), _vm._v(" "), _c('label', {
    staticClass: "col-sm-1 control-label",
    attrs: {
      "for": "fimDoTurno"
    }
  }, [_vm._v("Término")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2"
  }, [_c('vue-timepicker', {
    attrs: {
      "format": "HH:mm"
    },
    model: {
      value: (_vm.paradaSelecionada.horaFim),
      callback: function($$v) {
        _vm.$set(_vm.paradaSelecionada, "horaFim", $$v)
      },
      expression: "paradaSelecionada.horaFim"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-sm-12"
  }, [_c('div', {
    staticClass: "col-sm-1"
  }, [_c('button', {
    staticClass: "btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.voltarTurno()
      }
    }
  }, [_vm._v("Voltar")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-1"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.gravarParadaProgramada()
      }
    }
  }, [_vm._v("Gravar Parada")])])])])]) : _vm._e(), _vm._v(" "), (_vm.turnoSelecionado.turno.id !== 0) ? _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.exibirNovaParada),
      expression: "!exibirNovaParada"
    }],
    staticClass: "box"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "box-body no-padding table-responsive"
  }, [_c('div', {
    staticClass: "box-body no-padding table-responsive  col-md-12"
  }, [_c('table', {
    staticClass: "table table-striped"
  }, [_c('tbody', [_vm._m(5), _vm._v(" "), _vm._l((_vm.paradasprogramadas), function(parada) {
    return _c('tr', {
      key: parada.id
    }, [_c('td', [_vm._v(_vm._s(parada.nomeparadaprogramada))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(parada.horainicio))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(parada.horafim))]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "text-center"
    }, [_c('a', {
      staticClass: "btn btn-sm",
      on: {
        "click": function($event) {
          return _vm.editarParadaProgramada(parada)
        }
      }
    }, [_vm._m(6, true)]), _vm._v(" "), _c('a', {
      staticClass: "btn btn-sm",
      attrs: {
        "data-toggle": "modal",
        "data-target": "#confirmacaoModal"
      },
      on: {
        "click": function($event) {
          return _vm.prepararDeletarParada(parada)
        }
      }
    }, [_vm._m(7, true)])])])])
  })], 2)])])]), _vm._v(" "), _c('div', {
    staticClass: "box-footer"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.novaParadaProgramada()
      }
    }
  }, [_vm._v("Nova Parada Programada")])])])]) : _vm._e()])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', [_vm._v("Nome")]), _vm._v(" "), _c('th', [_vm._v("Início")]), _vm._v(" "), _c('th', [_vm._v("Término")]), _vm._v(" "), _c('th', [_vm._v("Tempo Total")]), _vm._v(" "), _c('th', [_vm._v("Tempo Paradas")]), _vm._v(" "), _c('th', [_vm._v("Tempo Útil")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Ações")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "pull-right badge bg-blue"
  }, [_c('i', {
    staticClass: "fa fa-edit"
  }), _vm._v(" Editar / Detalhar")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "pull-right badge bg-red"
  }, [_c('i', {
    staticClass: "fa fa-trash"
  }), _vm._v(" Apagar")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Paradas Programadas")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', [_vm._v("Nome da Parada")]), _vm._v(" "), _c('th', [_vm._v("Hora de Início")]), _vm._v(" "), _c('th', [_vm._v("Hora de Término")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Ações")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "pull-right badge bg-blue"
  }, [_c('i', {
    staticClass: "fa fa-edit"
  }), _vm._v(" Editar")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "pull-right badge bg-red"
  }, [_c('i', {
    staticClass: "fa fa-trash"
  }), _vm._v(" Apagar")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bef7155c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Turnos.vue
// module id = 628
// module chunks = 1